// extracted by mini-css-extract-plugin
export var container = "_5r-0";
export var fallback = "_5r-5";
export var fallbackIcon = "_5r-6";
export var hidden = "_5r-2";
export var image = "_5r-3";
export var loaded = "_5r-4";
export var placeholder = "_5r-1";